export default __webpack_public_path__ + "static/media/usa.b4977060.webp";